import { createAction } from '../../../core/helpers'

import { COMMON_FETCH_DISH_TYPES } from '../action-types'

const cleanupCommonFetchDishTypes = createAction(
  COMMON_FETCH_DISH_TYPES.CLEANUP,
)

export default cleanupCommonFetchDishTypes
